export default __webpack_public_path__ + "static/unitedincome-0512e495843079743bf8a5938f036e11.png";